export default {
  en: {
    includedRegistrations: 'Included registrations',
  },
  es: {
    includedRegistrations: 'Inscripcioness incluidas',
  },
};
